import SearchBar from 'components/SearchBar/SearchBar';
import UserMenuPanel from 'features/UserMenu/components/UserMenuPanel/UserMenuPanel';
import { Container } from 'react-bootstrap';
import { FaHouse, FaMapLocation } from 'react-icons/fa6';

/** Arrange the place editor and saved places with appearance-specific colors. */
const PlacesLayout = ({
  isClassic,
  canEditPlaces,
  searchControl,
  mapPreview,
  selectedAddress,
  saveButton,
  children,
}) => (
  <Container
    fluid
    className="page-scroll-area user-menu-page px-0"
    data-appearance={isClassic ? 'classic' : 'merlin'}
  >
    <div className="user-menu-grid" data-layout="halves-wide">
      {canEditPlaces && (
        <UserMenuPanel icon={<FaMapLocation />} title="Add a Place">
          <div>{searchControl}</div>
          <div className="ratio ratio-4x3 w-100 user-menu-place-map">{mapPreview}</div>
          <div className="user-menu-actions">
            <p className="mb-0">{selectedAddress}</p>
            {saveButton}
          </div>
        </UserMenuPanel>
      )}
      <UserMenuPanel
        icon={<FaHouse />}
        title="Saved Places"
        actions={<SearchBar className="p-2 rounded-4 w-auto border-0" />}
      >
        {children}
      </UserMenuPanel>
    </div>
  </Container>
);

export default PlacesLayout;
